import React from "react";
import { store } from "../../../Website/CoverPage/store";
import { useSnapshot } from "valtio";
import { templateStore } from "../../../templateStore";
import {
    footerLegalInfo,
    socialMediaImages,
    useTemplateData,
} from "@constants/template";
import { NoPicture } from "@components/Common/SvgIcons";

function Preview() {
    const { selectedLanguage } = useSnapshot(store);
    const snap = useSnapshot(templateStore);
    function getNesteddValue(
        path: string[],
        field: string,
        lang: string,
        obj: any,
        isMultilingual: boolean = true
    ): any {
        try {
            let current = obj;
            for (const key of path) {
                if (current[key] === undefined) return "";
                current = current[key];
            }

            if (!current[field]) return "";

            return isMultilingual ? current[field][lang] || "" : current[field];
        } catch {
            return "";
        }
    }

    const description = React.useMemo(() => {
        return getNesteddValue(
            ["SiteWeb", "Divers", "Footer"],
            "Description",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage]);
    const followUsMessage = React.useMemo(() => {
        return getNesteddValue(
            ["SiteWeb", "Divers", "Footer"],
            "FollowUs",
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage]);
    const { getImageUrl, iuud } = useTemplateData();

    const iconUrl = getImageUrl(
        ["SiteWeb", "ChoixBoutique", "Boutique", "Default", "Logo", "Desktop"],
        iuud
    );

    const socialMedia = React.useMemo(() => {
        return getNesteddValue(
            ["SiteWeb", "Divers"],
            "SocialMedia", // ← swap this field name
            selectedLanguage,
            snap.template,
            false
        );
    }, [snap.template, selectedLanguage]);
    return (
        <div
            className="mt-2"
            style={{
                padding: "3%",
                height: "100%",
                maxHeight: "100%",
                overflow: "hidden",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
            }}
        >
            <div
                style={{
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                    width: "30%",
                    height: "100%",
                    overflow: "hidden",
                    textAlign: "center",
                }}
            >
                {iconUrl !== "" ? (
                    <img src={iconUrl} alt="" height={50} width={50} />
                ) : (
                    <div>
                        {" "}
                        <NoPicture height={50} width={50} />
                    </div>
                )}
                <p style={{ width: "60%" }}>{description}</p>
            </div>
            <div
                style={{
                    width: "30%",
                    height: "100%",
                    overflow: "hidden",
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-center",
                }}
            >
                <div>
                    <h6>
                        {footerLegalInfo.LegalInformation[selectedLanguage]}
                    </h6>
                    <p style={{ marginBottom: "3px" }}>
                        {footerLegalInfo.LegalNotice[selectedLanguage]}
                    </p>
                    <p style={{ marginBottom: "3px" }}>
                        {footerLegalInfo.PrivacyPolicy[selectedLanguage]}
                    </p>
                    <p style={{ marginBottom: "3px" }}>
                        {footerLegalInfo.TermsOfSale[selectedLanguage]}
                    </p>
                    <p style={{ marginBottom: "3px" }}>
                        {footerLegalInfo.TermsOfUse[selectedLanguage]}
                    </p>
                </div>
            </div>
            <div
                style={{
                    width: "30%",
                    height: "100%",
                    overflow: "hidden",
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                }}
            >
                {" "}
                <div>
                    <h6>{followUsMessage}</h6>
                    <div
                        style={{
                            display: "flex",
                            gap: "15px",
                            flexWrap: "wrap",
                            marginTop: "10px",
                            marginBottom: "10px",
                        }}
                    >
                        {Object.entries(socialMedia).map(
                            ([platform, data]: any) =>
                                data.Activer === true ? (
                                    <img
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                        }}
                                        key={platform}
                                        src={socialMediaImages[platform]}
                                        alt={platform}
                                    />
                                ) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Preview;
